import React, { useState } from "react";
import ExamsModal from "../../modals/admin/reports/ExamsModal";
import AttendanceModal from "../../modals/admin/reports/AttendanceModal";
import ListOfStudentModal from "../../modals/admin/reports/ListOfStudent";
import { useTranslation } from 'react-i18next';
import StudentProfileModal from "../../modals/admin/reports/StudentProfile";
import ListOfTeacherModal from "../../modals/admin/reports/ListOfTeacher";
import TeacherProfileModal from "../../modals/admin/reports/TeacherProfile";
import Attendance from "../../modals/admin/reports/Attendance";
import OverAllExamsReport from "../../modals/admin/reports/OverAllExamsReport";
import Surveys from "../../modals/admin/reports/Surveys";
import ComplaintsFeedbacks from "../../modals/admin/reports/ComplaintsFeedbacks";
import Financials from "../../modals/admin/reports/Financials";
import IncidentReporting from "../../modals/admin/reports/IncidentReporting";
import CurriculamProgressReport from "../../modals/admin/reports/CurriculamProgressReport";
import CoursesReport from "../../modals/admin/reports/CoursesReport";
import ParentEngagementReportIndvidual from "../../modals/admin/reports/ParentEngagementReportIndvidual";
import ParentEngagementReportGroup from "../../modals/admin/reports/ParentEngagementReportGroup";
import WiserAdviserTeacher from "../../modals/admin/reports/Wiser-AdviserTeacher";
import WiserAdviserStudent from "../../modals/admin/reports/WiserAdviserStudent";


const reportCategories = [
  {
    title: 'List Of Students',
  },
  {
    title: 'Student Profile',
  },
  {
    title: 'List Of Teachers',
  },
  {
    title: 'Teacher Profile',
  },
  {
    title: 'Attendance',
  },
  {
    title: 'Individual Exams Report',
  },
  {
    title: 'Overall Exams Report',
  },
  {
    title: 'Surveys',
  },
  {
    title: 'Complaints And Feedbacks',
  },
  {
    title: 'Financials Fees Only',
  },
  {
    title: 'Incident Reporting',
  },
  {
    title: 'Curriculam Progress Report',
  },
  {
    title: 'Courses Report',
  },
  {
    title: 'Parent Engagement Report Individual',
  },
  {
    title: 'Parent Engagement ReportGroup',
  },
  {
    title: 'Wiser-Adviser (Teacher)',
  },
  {
    title: 'Wiser-Adviser (Student)',
  },
];

const Reports = () => {
  const [openModal, setOpenModal] = useState(null);
  const { t } = useTranslation();

  const handleOpenModal = (title) => {
    setOpenModal(title);
  };

  const handleCloseModal = () => {
    setOpenModal(null);
  };

  return (
    <div className="max-w-6xl mx-auto p-6">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {reportCategories.map((category, index) => (
          <div key={index} className="bg-gradient-to-t from-[#241763] via-[#3c2a8a] to-[#5b4b9a] p-4 rounded-lg shadow-md hover:shadow-lg transition-all duration-300 transform hover:scale-105">
            <button
              onClick={() => handleOpenModal(category.title)}
              className="text-lg font-bold text-white text-center mb-2 hover:text-indigo-200 hover:underline cursor-pointer text-left w-full"
            >
              {t(category.title)}
            </button>
          </div>
        ))}
      </div>

      {/* Conditionally Render Modals */}
      {openModal === "Individual Exams Report" && <ExamsModal isOpen={true} onClose={handleCloseModal} />}
      {openModal === "List Of Students" && <ListOfStudentModal isOpen={true} onClose={handleCloseModal} />}
      {openModal === "Student Profile" && <StudentProfileModal isOpen={true} onClose={handleCloseModal} />}
      {openModal === "List Of Teachers" && <ListOfTeacherModal isOpen={true} onClose={handleCloseModal} />}
      {openModal === "Teacher Profile" && <TeacherProfileModal isOpen={true} onClose={handleCloseModal} />}
      {openModal === "Attendance" && <Attendance isOpen={true} onClose={handleCloseModal} />}
      {openModal === "Overall Exams Report" && <OverAllExamsReport isOpen={true} onClose={handleCloseModal} />}
      {openModal === "Surveys" && <Surveys isOpen={true} onClose={handleCloseModal} />}
      {openModal === "Complaints And Feedbacks" && <ComplaintsFeedbacks isOpen={true} onClose={handleCloseModal} />}
      {openModal === "Financials Fees Only" && <Financials isOpen={true} onClose={handleCloseModal} />}
      {openModal === "Incident Reporting" && <IncidentReporting isOpen={true} onClose={handleCloseModal} />}
      {openModal === "Curriculam Progress Report" && <CurriculamProgressReport isOpen={true} onClose={handleCloseModal} />}
      {openModal === "Courses Report" && <CoursesReport isOpen={true} onClose={handleCloseModal} />}
      {openModal === "Parent Engagement Report Individual" && <ParentEngagementReportIndvidual isOpen={true} onClose={handleCloseModal} />}
      {openModal === "Parent Engagement ReportGroup" && <ParentEngagementReportGroup isOpen={true} onClose={handleCloseModal} />}
      {openModal === "Wiser-Adviser (Teacher)" && <WiserAdviserTeacher isOpen={true} onClose={handleCloseModal} />}
      {openModal === "Wiser-Adviser (Student)" && <WiserAdviserStudent isOpen={true} onClose={handleCloseModal} />}
  
    </div>
  );
};

export default Reports;
